// import React, { useCallback, useEffect, useState } from "react";
// import {
//   Container, Row, Col, Card, Table, Button, Form, Pagination, Spinner, Alert, Modal,
// } from "react-bootstrap";
// import axios from "axios";
// import {
//   BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid,
// } from "recharts";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import "./FinanceReport.css";
// import { URL } from "../../../config";

// const COLORS = {
//   recharge: "#0ea5e9",   // sky
//   commission: "#10b981", // emerald
//   rewards: "#f59e0b",    // amber
//   profit: "#6366f1",     // indigo
// };

// const FinanceReport = () => {
//   const token = localStorage.getItem("adminToken");

//   // Filters & UI
//   const [startDate, setStartDate]   = useState("");
//   const [endDate, setEndDate]       = useState("");
//   const [loading, setLoading]       = useState(true);
//   const [error, setError]           = useState("");
//   const [viewMode, setViewMode]     = useState("table"); // "table" | "graph"

//   // Summary + charts
//   const [summary, setSummary]       = useState({
//     totals: {
//       totalRechargeAmount: 0,
//       totalCommission: 0,
//       totalRewardAmount: 0,
//       rewardCount: 0,
//       rewardPerUser: 200,
//       reserveBalance: 0,
//       pendingCommissionTotal: 0,
//       profit: 0,
//     },
//     monthSeries: [],
//   });

//   // Ledger (table + pdf)
//   const [ledger, setLedger]         = useState([]);

//   // Table pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 12;

//   // Modal (View action)
//   const [showModal, setShowModal]   = useState(false);
//   const [selectedRow, setSelectedRow] = useState(null);

//   const openView = (row) => { setSelectedRow(row); setShowModal(true); };
//   const closeView = () => { setShowModal(false); setSelectedRow(null); };

//   const fetchAll = useCallback(
//     async (sDate, eDate) => {
//       setLoading(true);
//       try {
//         let qs = "";
//         if (sDate && eDate) qs = `?startDate=${sDate}&endDate=${eDate}`;

//         const [sumRes, ledgerRes] = await Promise.all([
//           axios.get(`${URL}/finance/summary${qs}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           }),
//           axios.get(`${URL}/finance/ledger${qs}`, {
//             headers: { Authorization: `Bearer ${token}` },
//           }),
//         ]);

//         setSummary(sumRes.data || { totals: {}, monthSeries: [] });
//         setLedger(ledgerRes.data || []);
//         setCurrentPage(1);
//         setError("");
//       } catch (e) {
//         console.error("Finance fetch error:", e);
//         setError("Failed to load finance data. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [token]
//   );

//   useEffect(() => { fetchAll(); }, [fetchAll]);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (startDate && endDate) fetchAll(startDate, endDate);
//     else fetchAll();
//   };

//   const handleReset = () => {
//     setStartDate("");
//     setEndDate("");
//     fetchAll();
//   };

//   // Helpers
//   const formatDate = (iso) => {
//     const d = new Date(iso);
//     const dateStr = d.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
//     const [month, day, year] = dateStr.replace(",", "").split(" ");
//     return `${day}-${month}-${year}`;
//   };

//   const formatDateTime = (iso) => {
//     const d = new Date(iso);
//     const date = formatDate(iso);
//     const time = d
//       .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true })
//       .toLowerCase();
//     return `${date}, ${time}`;
//   };

//   const money = (n) => {
//     if (typeof n !== "number") return "0.00 Tk";
//     return n >= 0 ? `${n.toFixed(2)} Tk` : `(${Math.abs(n).toFixed(2)} Tk)`;
//   };

//   // Table pagination computations
//   const totalResults     = ledger.length;
//   const indexOfLastItem  = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems     = ledger.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages       = Math.ceil(totalResults / itemsPerPage);
//   const handlePageChange = (p) => setCurrentPage(p);

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end   = Math.min(total - 1, current + siblings);
//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   // Chart series
//   const chartData = (summary.monthSeries || []).map(m => ({
//     month: m.month,
//     recharge: Number(m.recharge || 0),
//     commission: Number(m.commission || 0),
//     // rewards: Number(m.rewards || 0),
//     rewards: Number((m.rewards || 0) + (m.servitorBonus || 0)),
//     profit: Number(m.profit || 0),
//   }));

//   // Helpers
//     const MONTH_ABBR = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

//     const formatDateShort = (iso) => {
//     const d = new Date(iso);
//     const dd = String(d.getDate()).padStart(2, "0");
//     const mon = MONTH_ABBR[d.getMonth()];
//     const yy = String(d.getFullYear()).slice(-2);
//     return `${dd}-${mon}-${yy}`; // e.g., 20-Sep-25
//     };

//     // const formatDateLong = (iso) => {
//     // const d = new Date(iso);
//     // const dateStr = d.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
//     // const [month, day, year] = dateStr.replace(",", "").split(" ");
//     // const time = d
//     //     .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true })
//     //     .toLowerCase();
//     // return `${day}-${month}-${year}, ${time}`; // e.g., 25-September-2025, 1:12:12 pm
//     // };


//   // PDF download
//   const handleDownloadPDF = () => {
//     const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });
//     const { totals } = summary;

//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(20);
//     doc.text("Finance Report", 40, 42);

//     if (startDate && endDate) {
//       doc.setFont("helvetica", "normal");
//       doc.setFontSize(11);
//       doc.text(`Date Range: ${startDate} to ${endDate}`, 40, 62);
//     }

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(13);
//     const lines = [
//       `Total Recharge Amount: ${totals?.totalRechargeAmount?.toFixed(2) || "0.00"} Tk`,
//       `Total Commission: ${totals?.totalCommission?.toFixed(2) || "0.00"} Tk`,
//       `Total Reward + Servitor Bonus: ${totals?.totalRewardAmount?.toFixed(2) || "0.00"} Tk (Users rewarded: ${totals?.rewardCount || 0} × ${totals?.rewardPerUser || 200})`,
//       `Reserve Balance (liability): ${totals?.reserveBalance?.toFixed(2) || "0.00"} Tk`,
//       `Pending Commission (reserved): ${totals?.pendingCommissionTotal?.toFixed(2) || "0.00"} Tk`,
//     //   `Profit = Commission - Rewards: ${totals?.profit?.toFixed(2) || "0.00"} Tk`,
//       `Profit: ${totals?.profit?.toFixed(2) || "0.00"} Tk`,
//     ];
//     let y = 88;
//     lines.forEach(line => { doc.text(line, 40, y); y += 18; });

//     const tableBody = ledger.map((r, idx) => ([
//       idx + 1,
//       r.type || "",
//       r.ref || "",
//       r.party || "",
//       r.partyId || "",
//       r.mobile || "",
//       r.method || "",
//       (typeof r.amount === "number" ? r.amount.toFixed(2) : "0.00") + " Tk",
//       r.direction === "in" ? "Inflow" : "Outflow",
//     //   formatDate(r.date),
//       formatDateShort(r.date),
//     ]));

//     autoTable(doc, {
//       startY: y + 12,
//       head: [[ "#", "Type", "Reference", "Party", "Party ID", "Mobile", "Method", "Amount", "Flow", "Date" ]],
//       body: tableBody,
//       theme: "striped",
//       styles: { fontSize: 10, cellPadding: 4, overflow: "linebreak" },
//       headStyles: { fillColor: [16, 185, 129], textColor: 255, fontStyle: "bold" },
//       columnStyles: {
//         0: { cellWidth: 35 },
//         1: { cellWidth: 80 },
//         2: { cellWidth: 110 },
//         3: { cellWidth: 110 },
//         4: { cellWidth: 80 },
//         5: { cellWidth: 80 },
//         6: { cellWidth: 80 },
//         7: { cellWidth: 80, halign: "right" },
//         8: { cellWidth: 60 },
//         9: { cellWidth: 80 },

//         // 3: { cellWidth: 110 }, // Party
//         // 9: { cellWidth: 140 }, // Note
//         // 10:{ cellWidth: 120 }, // Date
//       },
//       willDrawCell: (data) => {
//         if (data.section === "body" && data.column.index === 7) {
//           data.cell.styles.halign = "right";
//         }
//       }
//     });

//     doc.save(`finance-report${startDate && endDate ? `-${startDate}_to_${endDate}` : ""}.pdf`);
//   };

//   // ✅ Use `totals` (prevents no-unused-vars)
//   const { totals } = summary;

//   return (
//     <Container fluid className="financeReport-container">
//       <Card className="financeReport-card">
//         <Card.Header className="financeReport-header">
//           <h4 className="financeReport-title">Finance Report</h4>
//         </Card.Header>

//         <Card.Body>
//           {/* Summary Cards */}
//           <div className="financeReport-stats">
//             <div className="financeReport-stat financeReport-greenTint">
//               <div className="financeReport-stat-icon"><i className="fas fa-wallet"/></div>
//               <div className="financeReport-stat-title">TOTAL RECHARGE AMOUNT</div>
//               <div className="financeReport-stat-value">{(totals.totalRechargeAmount || 0).toFixed(2)} Tk</div>
//             </div>

//             <div className="financeReport-stat financeReport-blueTint">
//               <div className="financeReport-stat-icon"><i className="fas fa-coins"/></div>
//               <div className="financeReport-stat-title">TOTAL COMMISSION</div>
//               <div className="financeReport-stat-value">{(totals.totalCommission || 0).toFixed(2)} Tk</div>
//             </div>

//             <div className="financeReport-stat financeReport-amberTint">
//               <div className="financeReport-stat-icon"><i className="fas fa-gift"/></div>
//               <div className="financeReport-stat-title">TOTAL REWARD + SERVITOR BONUS</div>
//               <div className="financeReport-stat-value">{(totals.totalRewardAmount || 0).toFixed(2)} Tk</div>
//             </div>

//             <div className="financeReport-stat financeReport-purpleTint">
//               <div className="financeReport-stat-icon"><i className="fas fa-piggy-bank"/></div>
//               <div className="financeReport-stat-title">RESERVE BALANCE (OWED)</div>
//               <div className="financeReport-stat-value">{(totals.reserveBalance || 0).toFixed(2)} Tk</div>
//             </div>

//             <div className="financeReport-stat financeReport-indigoTint">
//               <div className="financeReport-stat-icon"><i className="fas fa-chart-line"/></div>
//               {/* <div className="financeReport-stat-title">PROFIT (COMMISSION − REWARDS)</div> */}
//               <div className="financeReport-stat-title">PROFIT</div>
//               <div className="financeReport-stat-value">{(totals.profit || 0).toFixed(2)} Tk</div>
//             </div>
//           </div>

//           {/* Filters */}
//           <Form onSubmit={handleSearch} className="mb-3">
//             <Row className="align-items-end">
//               <Col md={4} className="mb-2">
//                 <Form.Group controlId="startDate">
//                   <Form.Label>Start Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     className="financeReport-input"
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-2">
//                 <Form.Group controlId="endDate">
//                   <Form.Label>End Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="financeReport-input"
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-2 d-flex">
//                 <div className="ms-auto">
//                   <Button variant="primary" type="submit" className="me-2 financeReport-btn">
//                     Search
//                   </Button>
//                   <Button
//                     variant="outline-primary"
//                     onClick={handleReset}
//                     className="financeReport-btn"
//                   >
//                     Reset
//                   </Button>
//                 </div>
//               </Col>
//             </Row>
//           </Form>

//           {/* View & Download Controls */}
//           <div className="financeReport-controls">
//             <div className="financeReport-toggle">
//               <Button
//                 variant={viewMode === "table" ? "primary" : "outline-primary"}
//                 className="financeReport-btn"
//                 onClick={() => setViewMode("table")}
//               >
//                 Table View
//               </Button>
//               <Button
//                 variant={viewMode === "graph" ? "primary" : "outline-primary"}
//                 className="financeReport-btn"
//                 onClick={() => setViewMode("graph")}
//               >
//                 Graph View
//               </Button>
//             </div>
//             <div className="financeReport-actions">
//               <Button variant="outline-dark" className="financeReport-btn" onClick={handleDownloadPDF}>
//                 Download PDF
//               </Button>
//             </div>
//           </div>

//           {loading && (
//             <div className="text-center"><Spinner animation="border" /></div>
//           )}
//           {error && (
//             <Alert variant="danger" className="financeReport-error">{error}</Alert>
//           )}

//           {!loading && !error && (
//             <>
//               {viewMode === "graph" ? (
//                 // Graph View
//                 <Row>
//                   <Col md={12} className="mb-3">
//                     <Card className="financeReport-chart-card">
//                       <Card.Body>
//                         <h6 className="financeReport-chart-title">
//                           Month-wise: Recharge vs Commission vs Rewards vs Profit
//                         </h6>
//                         <div className="financeReport-chart-wrap">
//                           <ResponsiveContainer>
//                             <BarChart data={chartData} margin={{ top: 6, right: 10, bottom: 0, left: 0 }}>
//                               <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
//                               <XAxis dataKey="month" tick={{ fontSize: 12, fill: "#374151" }} axisLine={{ stroke: "#d1d5db" }} />
//                               <YAxis tick={{ fontSize: 12, fill: "#374151" }} axisLine={{ stroke: "#d1d5db" }} />
//                               <Tooltip
//                                 formatter={(value, name) => [`${Number(value).toFixed(2)} Tk`, name]}
//                                 labelStyle={{ fontWeight: 700 }}
//                                 contentStyle={{ borderRadius: 8, borderColor: "#e5e7eb" }}
//                               />
//                               <Legend verticalAlign="bottom" wrapperStyle={{ paddingTop: 8 }} />
//                               <Bar dataKey="recharge"   name="Recharge"   fill={COLORS.recharge}   radius={[6,6,0,0]} />
//                               <Bar dataKey="commission" name="Commission" fill={COLORS.commission} radius={[6,6,0,0]} />
//                               <Bar dataKey="rewards"    name="Rewards"    fill={COLORS.rewards}    radius={[6,6,0,0]} />
//                               <Bar dataKey="profit"     name="Profit"     fill={COLORS.profit}     radius={[6,6,0,0]} />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                 </Row>
//               ) : (
//                 // Table View
//                 <Card className="mt-2 financeReport-table-card">
//                   <Card.Header>
//                     {/* <div className="financeReport-table-head">
//                       <strong>Finance Ledger</strong>
//                       <small className="text-muted">Recharge / Commission / Reward</small>
//                     </div> */}
//                   </Card.Header>
//                   <Card.Body>
//                     {ledger.length === 0 ? (
//                       <p className="financeReport-empty">No records found in this period.</p>
//                     ) : (
//                       <>
//                         <div className="financeReport-table-responsive">
//                           <Table striped bordered hover className="financeReport-table">
//                             <thead>
//                               <tr>
//                                 <th className="financeReport-col-index">#</th>
//                                 <th>Type</th>
//                                 <th>Reference</th>
//                                 <th>Party</th>
//                                 <th>Party&nbsp;ID</th>
//                                 <th>Mobile</th>
//                                 <th>Method</th>
//                                 <th className="text-end">Amount</th>
//                                 <th>Flow</th>
//                                 <th>Date</th>
//                                 <th className="financeReport-col-action">Action</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {currentItems.map((r, idx) => (
//                                 <tr key={`${r.type}-${r.ref}-${idx}`}>
//                                   <td className="text-center">{idx + 1 + indexOfFirstItem}</td>
//                                   <td>{r.type}</td>
//                                   <td>{r.ref || ""}</td>
//                                   <td>{r.party || ""}</td>
//                                   <td>{r.partyId || ""}</td>
//                                   <td>{r.mobile || ""}</td>
//                                   <td>{r.method || ""}</td>
//                                   <td className="text-end">{money(r.amount)}</td>
//                                   <td>{r.direction === 'in' ? 'Inflow' : 'Outflow'}</td>
//                                   <td className="financeReport-nowrap">{formatDateShort(r.date)}</td>
//                                   <td className="text-center">
//                                     <Button
//                                       variant="link"
//                                       className="financeReport-viewBtn"
//                                       onClick={() => openView(r)}
//                                       aria-label="View details"
//                                       title="View details"
//                                     >
//                                       <i className="far fa-eye"></i>
//                                     </Button>
//                                   </td>
//                                 </tr>
//                               ))}
//                             </tbody>
//                           </Table>
//                         </div>

//                         <Pagination className="mt-2">
//                           <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1}/>
//                           <Pagination.Prev  onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}/>
//                           {getPageItems(totalPages, currentPage).map((item, ix) =>
//                             item === "start-ellipsis" || item === "end-ellipsis" ? (
//                               <Pagination.Ellipsis key={item + ix} disabled/>
//                             ) : (
//                               <Pagination.Item key={item} active={item === currentPage} onClick={() => handlePageChange(item)}>
//                                 {item}
//                               </Pagination.Item>
//                             )
//                           )}
//                           <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}/>
//                           <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}/>
//                         </Pagination>

//                         <div className="mt-1 text-muted financeReport-results">
//                           Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, totalResults)} of {totalResults} records
//                         </div>
//                       </>
//                     )}
//                   </Card.Body>
//                 </Card>
//               )}
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {/* View Modal */}
//       <Modal show={showModal} onHide={closeView} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Entry Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {selectedRow ? (
//             <>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Type</Col>
//                 <Col md={7}>{selectedRow.type || "-"}</Col>
//               </Row>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Reference</Col>
//                 <Col md={7}>{selectedRow.ref || "-"}</Col>
//               </Row>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Party</Col>
//                 <Col md={7}>{selectedRow.party || "-"}</Col>
//               </Row>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Party ID</Col>
//                 <Col md={7}>{selectedRow.partyId || "-"}</Col>
//               </Row>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Mobile</Col>
//                 <Col md={7}>{selectedRow.mobile || "-"}</Col>
//               </Row>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Method</Col>
//                 <Col md={7}>{selectedRow.method || "-"}</Col>
//               </Row>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Amount</Col>
//                 <Col md={7}>{money(selectedRow.amount)}</Col>
//               </Row>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Flow</Col>
//                 <Col md={7}>{selectedRow.direction === "in" ? "Inflow" : "Outflow"}</Col>
//               </Row>
//               <Row className="mb-2">
//                 <Col md={5} className="fw-semibold">Date & Time</Col>
//                 <Col md={7}>{formatDateTime(selectedRow.date)}</Col>
//               </Row>
//               <hr />
//               <Row>
//                 <Col md={5} className="fw-semibold">Note</Col>
//                 <Col md={7}>{selectedRow.note || "—"}</Col>
//               </Row>
//             </>
//           ) : (
//             <div>Loading…</div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={closeView}>Close</Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   );
// };

// export default FinanceReport;






// ***** Update with paginations backend (20-Oct-2025) ***** //
import React, { useCallback, useEffect, useState } from "react";
import {
  Container, Row, Col, Card, Table, Button, Form, Pagination, Spinner, Alert, Modal,
} from "react-bootstrap";
import axios from "axios";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid,
} from "recharts";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "./FinanceReport.css";
import { URL } from "../../../config";

const COLORS = {
  recharge: "#0ea5e9",   // sky
  commission: "#10b981", // emerald
  rewards: "#f59e0b",    // amber
  profit: "#6366f1",     // indigo
};

const MONTH_ABBR = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const FinanceReport = () => {
  const token = localStorage.getItem("adminToken");

  // Filters & UI
  const [startDate, setStartDate]   = useState("");
  const [endDate, setEndDate]       = useState("");
  const [flow, setFlow]             = useState("all");   // "all" | "in" | "out"
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState("");
  const [viewMode, setViewMode]     = useState("table"); // "table" | "graph"

  // Summary + charts
  const [summary, setSummary] = useState({
    totals: {
      totalRechargeAmount: 0,
      totalCommission: 0,
      totalRewardAmount: 0,
      rewardCount: 0,
      rewardPerUser: 200,
      reserveBalance: 0,
      pendingCommissionTotal: 0,
      profit: 0,
    },
    monthSeries: [],
  });

  // Ledger page slice + meta (backend pagination)
  const [ledger, setLedger] = useState([]);
  const [ledgerMeta, setLedgerMeta] = useState({
    page: 1,
    limit: 12,
    total: 0,
    totalPages: 1,
  });

  // Modal (View action)
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const openView = (row) => { setSelectedRow(row); setShowModal(true); };
  const closeView = () => { setShowModal(false); setSelectedRow(null); };

  const fetchAll = useCallback(
    async (sDate, eDate, pageOverride) => {
      setLoading(true);
      try {
        const page = pageOverride ?? ledgerMeta.page;

        // summary (not paginated)
        const qsSummary = (sDate && eDate) ? `?startDate=${sDate}&endDate=${eDate}` : "";
        const sumReq = axios.get(`${URL}/finance/summary${qsSummary}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });

        // ledger (paginated + flow)
        const ledReq = axios.get(`${URL}/finance/ledger`, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
          params: {
            page,
            limit: ledgerMeta.limit,
            startDate: sDate || undefined,
            endDate: eDate || undefined,
            flow: flow !== "all" ? flow : undefined,
          },
        });

        const [sumRes, ledgerRes] = await Promise.all([sumReq, ledReq]);

        // summary
        setSummary(sumRes.data || { totals: {}, monthSeries: [] });

        // ledger + meta
        const list = Array.isArray(ledgerRes.data) ? ledgerRes.data : ledgerRes.data?.data || [];
        const meta = ledgerRes.data?.meta || {
          page,
          limit: ledgerMeta.limit,
          total: list.length,
          totalPages: Math.max(1, Math.ceil(list.length / ledgerMeta.limit)),
        };

        setLedger(list);
        setLedgerMeta({
          page: Number(meta.page || 1),
          limit: Number(meta.limit || 12),
          total: Number(meta.total || list.length || 0),
          totalPages: Number(meta.totalPages || 1),
        });

        setError("");
      } catch (e) {
        console.error("Finance fetch error:", e);
        setError("Failed to load finance data. Please try again.");
        setLedger([]);
        setLedgerMeta(m => ({ ...m, total: 0, totalPages: 1 }));
      } finally {
        setLoading(false);
      }
    },
    [token, ledgerMeta.page, ledgerMeta.limit, flow]
  );

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleSearch = (e) => {
    e.preventDefault();
    // reset to page 1 with current filters
    setLedgerMeta(m => ({ ...m, page: 1 }));
    fetchAll(startDate || undefined, endDate || undefined, 1);
  };

  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setFlow("all");
    setLedgerMeta(m => ({ ...m, page: 1 }));
    fetchAll(undefined, undefined, 1);
  };

  // Pagination
  const handlePageChange = (p) => {
    setLedgerMeta(m => ({ ...m, page: p }));
    fetchAll(startDate || undefined, endDate || undefined, p);
  };

  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end   = Math.min(total - 1, current + siblings);
    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  // Helpers
  const formatDateShort = (iso) => {
    const d = new Date(iso);
    const dd = String(d.getDate()).padStart(2, "0");
    const mon = MONTH_ABBR[d.getMonth()];
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}-${mon}-${yy}`;
  };

  const formatDateTime = (iso) => {
    const d = new Date(iso);
    const dateStr = d.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
    const [month, day, year] = dateStr.replace(",", "").split(" ");
    const time = d
      .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", second: "2-digit", hour12: true })
      .toLowerCase();
    return `${day}-${month}-${year}, ${time}`;
  };

  const moneySigned = (direction, amountNum) => {
    const v = Number(amountNum || 0);
    const abs = Math.abs(v).toFixed(2);
    return direction === 'in' ? `+${abs} Tk` : `-${abs} Tk`;
  };

  // Chart series
  const chartData = (summary.monthSeries || []).map(m => ({
    month: m.month,
    recharge: Number(m.recharge || 0),
    commission: Number(m.commission || 0),
    rewards: Number((m.rewards || 0) + (m.servitorBonus || 0)),
    profit: Number(m.profit || 0),
  }));

  // PDF (export ALL rows for the active filters)
  const handleDownloadPDF = async () => {
    try {
      const { data } = await axios.get(`${URL}/finance/ledger`, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        params: {
          startDate: startDate || undefined,
          endDate:   endDate   || undefined,
          flow: flow !== "all" ? flow : undefined,
          exportAll: 1, // tells backend to return ALL (no paging)
        },
      });

      const rows = Array.isArray(data) ? data : (data?.data || []);

      const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "A4" });
      const { totals } = summary;

      doc.setFont("helvetica", "bold");
      doc.setFontSize(20);
      doc.text("Finance Report", 40, 42);

      if (startDate && endDate) {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        doc.text(`Date Range: ${startDate} to ${endDate}`, 40, 62);
      }
      if (flow !== "all") {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(11);
        doc.text(`Flow: ${flow === "in" ? "Inflow" : "Outflow"}`, 40, 80);
      }

      doc.setFont("helvetica", "normal");
      doc.setFontSize(13);
      const lines = [
        `Total Recharge Amount: ${(totals?.totalRechargeAmount || 0).toFixed(2)} Tk`,
        `Total Commission: ${(totals?.totalCommission || 0).toFixed(2)} Tk`,
        `Total Reward + Servitor Bonus: ${(totals?.totalRewardAmount || 0).toFixed(2)} Tk (Users rewarded: ${totals?.rewardCount || 0} × ${totals?.rewardPerUser || 200})`,
        `Reserve Balance (liability): ${(totals?.reserveBalance || 0).toFixed(2)} Tk`,
        `Pending Commission (reserved): ${(totals?.pendingCommissionTotal || 0).toFixed(2)} Tk`,
        `Profit: ${(totals?.profit || 0).toFixed(2)} Tk`,
      ];
      let y = 98;
      lines.forEach(line => { doc.text(line, 40, y); y += 18; });

      const tableBody = rows.map((r, idx) => ([
        idx + 1,
        r.type || "",
        r.ref || "",
        r.party || "",
        r.partyId || "",
        r.mobile || "",
        r.method || "",
        moneySigned(r.direction, r.amount),
        r.direction === "in" ? "Inflow" : "Outflow",
        formatDateShort(r.date),
      ]));

      autoTable(doc, {
        startY: y + 12,
        head: [[ "#", "Type", "Reference", "Party", "Party ID", "Mobile", "Method", "Amount", "Flow", "Date" ]],
        body: tableBody,
        theme: "striped",
        styles: { fontSize: 10, cellPadding: 4, overflow: "linebreak" },
        headStyles: { fillColor: [16, 185, 129], textColor: 255, fontStyle: "bold" },
        columnStyles: {
          0: { cellWidth: 35 },
          1: { cellWidth: 80 },
          2: { cellWidth: 110 },
          3: { cellWidth: 110 },
          4: { cellWidth: 80 },
          5: { cellWidth: 80 },
          6: { cellWidth: 80 },
          7: { cellWidth: 90, halign: "right" },
          8: { cellWidth: 70 },
          9: { cellWidth: 80 },
        },
        willDrawCell: (data) => {
          if (data.section === "body" && data.column.index === 7) {
            data.cell.styles.halign = "right";
          }
        }
      });

      doc.save(`finance-report${startDate && endDate ? `-${startDate}_to_${endDate}` : ""}${flow !== "all" ? `-${flow}` : ""}.pdf`);
    } catch (err) {
      console.error("PDF export error:", err);
      alert("Failed to export PDF.");
    }
  };

  const { totals } = summary;

  return (
    <Container fluid className="financeReport-container">
      <Card className="financeReport-card">
        <Card.Header className="financeReport-header">
          <h4 className="financeReport-title">Finance Report</h4>
        </Card.Header>

        <Card.Body>
          {/* Summary Cards */}
          <div className="financeReport-stats">
            <div className="financeReport-stat financeReport-greenTint">
              <div className="financeReport-stat-icon"><i className="fas fa-wallet"/></div>
              <div className="financeReport-stat-title">TOTAL RECHARGE AMOUNT</div>
              <div className="financeReport-stat-value">{(totals.totalRechargeAmount || 0).toFixed(2)} Tk</div>
            </div>

            <div className="financeReport-stat financeReport-blueTint">
              <div className="financeReport-stat-icon"><i className="fas fa-coins"/></div>
              <div className="financeReport-stat-title">TOTAL COMMISSION</div>
              <div className="financeReport-stat-value">{(totals.totalCommission || 0).toFixed(2)} Tk</div>
            </div>

            <div className="financeReport-stat financeReport-amberTint">
              <div className="financeReport-stat-icon"><i className="fas fa-gift"/></div>
              <div className="financeReport-stat-title">TOTAL REWARD + SERVITOR BONUS</div>
              <div className="financeReport-stat-value">{(totals.totalRewardAmount || 0).toFixed(2)} Tk</div>
            </div>

            <div className="financeReport-stat financeReport-purpleTint">
              <div className="financeReport-stat-icon"><i className="fas fa-piggy-bank"/></div>
              <div className="financeReport-stat-title">RESERVE BALANCE (OWED)</div>
              <div className="financeReport-stat-value">{(totals.reserveBalance || 0).toFixed(2)} Tk</div>
            </div>

            <div className="financeReport-stat financeReport-indigoTint">
              <div className="financeReport-stat-icon"><i className="fas fa-chart-line"/></div>
              <div className="financeReport-stat-title">PROFIT</div>
              <div className="financeReport-stat-value">{(totals.profit || 0).toFixed(2)} Tk</div>
            </div>
          </div>

          {/* Filters */}
          <Form onSubmit={handleSearch} className="mb-3">
            <Row className="align-items-end">
              <Col md={3} className="mb-2">
                <Form.Group controlId="startDate">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="financeReport-input"
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-2">
                <Form.Group controlId="endDate">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="financeReport-input"
                  />
                </Form.Group>
              </Col>

              {/* Flow filter */}
              <Col md={3} className="mb-2">
                <Form.Group controlId="flow">
                  <Form.Label>Flow</Form.Label>
                  <Form.Select
                    value={flow}
                    onChange={(e) => setFlow(e.target.value)}
                    className="financeReport-input"
                  >
                    <option value="all">All</option>
                    <option value="in">Inflow</option>
                    <option value="out">Outflow</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={3} className="mb-2 d-flex">
                <div className="ms-auto">
                  <Button variant="primary" type="submit" className="me-2 financeReport-btn">
                    Search
                  </Button>
                  <Button variant="outline-primary" onClick={handleReset} className="financeReport-btn">
                    Reset
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>

          {/* View & Download Controls */}
          <div className="financeReport-controls">
            <div className="financeReport-toggle">
              <Button
                variant={viewMode === "table" ? "primary" : "outline-primary"}
                className="financeReport-btn"
                onClick={() => setViewMode("table")}
              >
                Table View
              </Button>
              <Button
                variant={viewMode === "graph" ? "primary" : "outline-primary"}
                className="financeReport-btn"
                onClick={() => setViewMode("graph")}
              >
                Graph View
              </Button>
            </div>
            <div className="financeReport-actions">
              <Button variant="outline-dark" className="financeReport-btn" onClick={handleDownloadPDF}>
                Download PDF
              </Button>
            </div>
          </div>

          {loading && (
            <div className="text-center"><Spinner animation="border" /></div>
          )}
          {error && (
            <Alert variant="danger" className="financeReport-error">{error}</Alert>
          )}

          {!loading && !error && (
            <>
              {viewMode === "graph" ? (
                // Graph View
                <Row>
                  <Col md={12} className="mb-3">
                    <Card className="financeReport-chart-card">
                      <Card.Body>
                        <h6 className="financeReport-chart-title">
                          Month-wise: Recharge vs Commission vs Rewards vs Profit
                        </h6>
                        <div className="financeReport-chart-wrap">
                          <ResponsiveContainer>
                            <BarChart data={chartData} margin={{ top: 6, right: 10, bottom: 0, left: 0 }}>
                              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                              <XAxis dataKey="month" tick={{ fontSize: 12, fill: "#374151" }} axisLine={{ stroke: "#d1d5db" }} />
                              <YAxis tick={{ fontSize: 12, fill: "#374151" }} axisLine={{ stroke: "#d1d5db" }} />
                              <Tooltip
                                formatter={(value, name) => [`${Number(value).toFixed(2)} Tk`, name]}
                                labelStyle={{ fontWeight: 700 }}
                                contentStyle={{ borderRadius: 8, borderColor: "#e5e7eb" }}
                              />
                              <Legend verticalAlign="bottom" wrapperStyle={{ paddingTop: 8 }} />
                              <Bar dataKey="recharge"   name="Recharge"   fill={COLORS.recharge}   radius={[6,6,0,0]} />
                              <Bar dataKey="commission" name="Commission" fill={COLORS.commission} radius={[6,6,0,0]} />
                              <Bar dataKey="rewards"    name="Rewards"    fill={COLORS.rewards}    radius={[6,6,0,0]} />
                              <Bar dataKey="profit"     name="Profit"     fill={COLORS.profit}     radius={[6,6,0,0]} />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              ) : (
                // Table View
                <Card className="mt-2 financeReport-table-card">
                  <Card.Header />
                  <Card.Body>
                    {ledger.length === 0 ? (
                      <p className="financeReport-empty">No records found in this period.</p>
                    ) : (
                      <>
                        <div className="financeReport-table-responsive">
                          <Table striped bordered hover className="financeReport-table">
                            <thead>
                              <tr>
                                <th className="financeReport-col-index">#</th>
                                <th>Type</th>
                                <th>Reference</th>
                                <th>Party</th>
                                <th>Party&nbsp;ID</th>
                                <th>Mobile</th>
                                <th>Method</th>
                                <th className="text-end">Amount</th>
                                <th>Flow</th>
                                <th>Date</th>
                                <th className="financeReport-col-action">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {ledger.map((r, idx) => {
                                const rowIndex = idx + 1 + (ledgerMeta.page - 1) * ledgerMeta.limit;
                                const isIn = r.direction === 'in';
                                return (
                                  <tr key={`${r.type}-${r.ref}-${idx}`}>
                                    <td className="text-center">{rowIndex}</td>
                                    <td>{r.type}</td>
                                    <td>{r.ref || ""}</td>
                                    <td>{r.party || ""}</td>
                                    <td>{r.partyId || ""}</td>
                                    <td>{r.mobile || ""}</td>
                                    <td>{r.method || ""}</td>
                                    <td className={`text-end ${isIn ? 'text-success' : 'text-danger'}`}>
                                      {isIn ? '+' : '-'}{Math.abs(Number(r.amount || 0)).toFixed(2)} Tk
                                    </td>
                                    <td>
                                      <span className={`badge ${isIn ? 'bg-success' : 'bg-danger'}`}>
                                        {isIn ? 'Inflow' : 'Outflow'}
                                      </span>
                                    </td>
                                    <td className="financeReport-nowrap">{formatDateShort(r.date)}</td>
                                    <td className="text-center">
                                      <Button
                                        variant="link"
                                        className="financeReport-viewBtn"
                                        onClick={() => openView(r)}
                                        aria-label="View details"
                                        title="View details"
                                      >
                                        <i className="far fa-eye"></i>
                                      </Button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>

                        {/* Server-side pagination controls */}
                        <Pagination className="mt-2">
                          <Pagination.First onClick={() => handlePageChange(1)} disabled={ledgerMeta.page === 1}/>
                          <Pagination.Prev  onClick={() => handlePageChange(ledgerMeta.page - 1)} disabled={ledgerMeta.page === 1}/>
                          {getPageItems(ledgerMeta.totalPages, ledgerMeta.page).map((item, ix) =>
                            item === "start-ellipsis" || item === "end-ellipsis" ? (
                              <Pagination.Ellipsis key={item + ix} disabled/>
                            ) : (
                              <Pagination.Item key={item} active={item === ledgerMeta.page} onClick={() => handlePageChange(item)}>
                                {item}
                              </Pagination.Item>
                            )
                          )}
                          <Pagination.Next onClick={() => handlePageChange(ledgerMeta.page + 1)} disabled={ledgerMeta.page === ledgerMeta.totalPages}/>
                          <Pagination.Last onClick={() => handlePageChange(ledgerMeta.totalPages)} disabled={ledgerMeta.page === ledgerMeta.totalPages}/>
                        </Pagination>

                        <div className="mt-1 text-muted financeReport-results">
                          Showing {(ledgerMeta.page - 1) * ledgerMeta.limit + 1} to {Math.min(ledgerMeta.page * ledgerMeta.limit, ledgerMeta.total)} of {ledgerMeta.total} records
                        </div>
                      </>
                    )}
                  </Card.Body>
                </Card>
              )}
            </>
          )}
        </Card.Body>
      </Card>

      {/* View Modal */}
      <Modal show={showModal} onHide={closeView} centered>
        <Modal.Header closeButton>
          <Modal.Title>Entry Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRow ? (
            <>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Type</Col>
                <Col md={7}>{selectedRow.type || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Reference</Col>
                <Col md={7}>{selectedRow.ref || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Party</Col>
                <Col md={7}>{selectedRow.party || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Party ID</Col>
                <Col md={7}>{selectedRow.partyId || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Mobile</Col>
                <Col md={7}>{selectedRow.mobile || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Method</Col>
                <Col md={7}>{selectedRow.method || "-"}</Col>
              </Row>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Amount</Col>
                <Col md={7} className={selectedRow.direction === 'in' ? 'text-success' : 'text-danger'}>
                  {moneySigned(selectedRow.direction, selectedRow.amount)}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Flow</Col>
                <Col md={7}>
                  <span className={`badge ${selectedRow.direction === 'in' ? 'bg-success' : 'bg-danger'}`}>
                    {selectedRow.direction === "in" ? "Inflow" : "Outflow"}
                  </span>
                </Col>
              </Row>
              <Row className="mb-2">
                <Col md={5} className="fw-semibold">Date & Time</Col>
                <Col md={7}>{formatDateTime(selectedRow.date)}</Col>
              </Row>
              <hr />
              <Row>
                <Col md={5} className="fw-semibold">Note</Col>
                <Col md={7}>{selectedRow.note || "—"}</Col>
              </Row>
            </>
          ) : (
            <div>Loading…</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeView}>Close</Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default FinanceReport;
